module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Regular.9863aaa.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Regular.woff
// module id = r3AI
// module chunks = 3